import { makeStyles } from '@material-ui/core/styles';

import { darkFullWhite } from '../../../service/getMuiThemeStyle';

export const useStyles = makeStyles((theme) => ({
    actionRoot: {
        position: 'relative',
        padding: theme.spacing(1, 1, 1, 2),

        color: 'white',
        backgroundColor: '#ffa000',
    },
    card: {
        width: '100%',
        marginTop: theme.spacing(0.5),

        backgroundColor: '#ffa000',
        pointerEvents: 'all',

        ['@media (min-width:370px)']: {
            maxWidth: 400,
            minWidth: 344,
        },
    },
    checkIcon: {
        paddingRight: 4,

        fontSize: 20,
        color: '#b3b3b3',
    },
    expand: {
        padding: theme.spacing(1, 1),

        transform: 'rotate(0)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    icons: {
        flex: '0 0 80px',
        marginLeft: 'auto',
        textAlign: 'right',
    },
    icon: {
        fill: darkFullWhite,
    },
    iconWrapper: {
        position: 'absolute',
        left: theme.spacing(2),
        top: theme.spacing(2),
    },
    text: {
        overflowX: 'auto',
    },
    title: {
        paddingLeft: theme.spacing(3.75),
        flexGrow: 1,
        color: darkFullWhite,

        fontSize: 18,
    },
}));
